import { Categoria } from '../../shared/entity/Categoria';
import { calcularTotalPedido, formatarDinheiro } from '../../shared/helper';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { DrawerNavigationProp } from '@react-navigation/drawer';
import { CompositeNavigationProp } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import React, { useEffect, useState } from 'react';
import { Platform, RefreshControl, StyleSheet, View } from 'react-native';
import { ActivityIndicator } from 'react-native-paper';
import { DrawerParamList, StackParamList } from '../../../App';
import produtoApi from '../../apis/produtoApi';
import colors from '../../colors';
import { SIDE_PADDING } from '../../constants';
import { usePedido } from '../../redux/pedido/pedidoHooks';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import Header from '../Generic/Header';
import PageContainer from '../Generic/PageContainer';
import ModalBaixarApp from '../Generic/ModalBaixarApp';
import ScrollComBotao from '../Generic/ScrollComBotao';
import ApresentacaoEmpresa from './ApresentacaoEmpresa';
import ItemCategoria from './ItemCategoria';
import { useEmpresa } from '../../redux/empresa/empresaHooks';
import ListaPromocoes from './ListaPromocoes';
import Cardapio from '../../shared/entity/Cardapio';
import cardapioApi from '../../apis/cardapioApi';

type Props = {
  navigation: CompositeNavigationProp<
    StackNavigationProp<StackParamList, 'HomeDrawer'>,
    DrawerNavigationProp<DrawerParamList, 'ProdutosPage'>
  >;
};

const ProdutosPage: React.FC<Props> = (props) => {
  const [pedido] = usePedido();
  const navigation = props.navigation;
  const [cardapio, setCardapio] = useState<Cardapio | null>(null);
  const [openModalPlataforma, setOpenModalPlataforma] = useState(Platform.OS === 'web');
  const [refreshing, setRefreshing] = useState(false);
  const [sessao, login, logout, revalidate] = useSessao();
  const [empresa] = useEmpresa();

  const getCardapio = async () => {
    try {
      const res = await cardapioApi.getCardapioCompleto({ empresaId: empresa.id });
      console.log('res cardapio', res);
      setCardapio(res);
    } catch (err) {
      setTimeout(() => {
        getCardapio();
      }, 5000);
    }
  };

  const refreshProdutos = async () => {
    setRefreshing(true);
    await getCardapio();
    setRefreshing(false);
  };

  const goToProduto = (id: number) => {
    navigation.navigate('AdicionarProdutoPage', { id: id });
  };

  useEffect(() => {
    getCardapio();
    revalidate();
  }, []);

  if (!cardapio) {
    return null;
  }

  return (
    <PageContainer scrollView={false} header={<Header openMenu={() => navigation.openDrawer()} />}>
      {/* <ModalBaixarApp
        show={openModalPlataforma && !empresa.esconderModalBaixarApp}
        onClose={() => setOpenModalPlataforma(false)}
      /> */}

      <ScrollComBotao
        onPress={() => navigation.navigate('PedidoPage')}
        buttonTitle={`Ver pedido (R$${formatarDinheiro(calcularTotalPedido(pedido, 0))})`}
        startIcon={
          <MaterialCommunityIcons name="food" size={40} color="white" style={{ marginRight: 5 }} />
        }
        refreshControl={<RefreshControl refreshing={refreshing} onRefresh={refreshProdutos} />}
      >
        <ApresentacaoEmpresa />

        <ListaPromocoes />

        {cardapio.categorias.length === 0 && <ActivityIndicator size={50} color={colors.primary} />}

        <View style={styles.content}>
          {cardapio.categorias.map((categoria) => (
            <ItemCategoria key={categoria.id} categoria={categoria} goToProduto={goToProduto} />
          ))}
        </View>
      </ScrollComBotao>
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    alignItems: 'center'
  },
  content: {
    paddingLeft: SIDE_PADDING,
    paddingRight: SIDE_PADDING,
    width: '100%',
    backgroundColor: '#fff',
    alignItems: 'center'
  },
  input: {
    borderBottomColor: colors.lightGrey,
    borderBottomWidth: 2,
    width: '100%',
    marginBottom: 15
  },
  button: {
    borderRadius: 5,
    backgroundColor: colors.button,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    alignItems: 'center',
    marginBottom: 10
  }
});

export default ProdutosPage;
